const enabledKey = (userId: number) => `po:switchTimeEnabled:${userId}`;
const durationKey = (userId: number) => `po:orderDuration:${userId}`;

/**
 * Последний выбор режима Time / Switch Time — per tab (sessionStorage, не localStorage,
 * чтобы другая открытая вкладка не влияла на выбор) и per user (ключ с user_id — смена
 * аккаунта в той же вкладке не подтягивает чужой выбор).
 */
export const getStoredSwitchTimeEnabled = (userId: number): boolean | null => {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(enabledKey(userId));
  return raw === null ? null : raw === "true";
};

export const setStoredSwitchTimeEnabled = (userId: number, enabled: boolean): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(enabledKey(userId), String(enabled));
};

export const getStoredDuration = (userId: number): number | null => {
  if (typeof window === "undefined") return null;
  const parsed = Number(sessionStorage.getItem(durationKey(userId)));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const setStoredDuration = (userId: number, duration: number): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(durationKey(userId), String(duration));
};

export const clearStoredTime = (userId: number): void => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(enabledKey(userId));
  sessionStorage.removeItem(durationKey(userId));
};
